import React, { useState, useEffect } from "react";
import Button from "../Common/Button";
import FilterComponent from "./FilterComponent";
import styles from "../style/style";
import { useDispatch, useSelector } from "react-redux";
import { IoAddCircleOutline } from "react-icons/io5";
import { SlActionUndo } from "react-icons/sl";
import { Link } from "react-router-dom";
import { actionIcon, deleteIcon, settingDataIcon, galleryIcon, paymentIcon } from "../img";
import { updatePlaceStatus, updatePackageCategoryStatus, updatePackageStatus, setPlaceSortOrder, updateTeamStatus, updateBankAccountStatus, updateCreditCardStatus, updatePhoneNumberStatus, updateBankAccessStatus, getAccessKeysData, updateNumberAccessStatus, setPackageSortOrder, setPackageCategorySortOrder, setBlogSortOrder, updateBlogStatus, updateLedgerOpeningBalance } from "../Redux/Action";
import { useNavigate } from "react-router-dom";
import { DndContext, closestCenter } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import TeamAccessPopup from '../Team/TeamAccessPopup';
import { FaRegEye, FaBalanceScale } from "react-icons/fa";
import Heading from "../Common/Heading";
import { LuShapes } from "react-icons/lu";

const SortableRow = ({ item, renderColumns, enableDragAndDrop }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item._id });
    const dragStyle = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <tr
            className="px-4 py-2 hover:bg-[#F5F5F5] border-b transition duration-500 text-sm border-[1px] items-center"
        >
            {renderColumns(item, { attributes, listeners, setNodeRef, dragStyle, enableDragAndDrop })}
        </tr>
    );
};

function DataTable({
    displayedData,
    toggleActions,
    Actions,
    handelFindDataByID,
    columns,
    contentName,
    urlName,
    addButtonLabel,
    bookingOnOff,
    setToggleMenu,
    toggleMenu,
    filters,
    handleFilterChange,
    totalData,
    title,
    loading,
    apiFunctionForDeleteUndo,
    showPageDetails = false,
    showUpdatePopup = false,
    deleteMultipleFunction,
    currentAction,
    showstatusToggel,
    showTableTitle,
    showSettingButton,
    enableDragAndDrop,
    showActionButtons,
    updateInSamePage,
    updateFunction,
    showDeleteBtn,
    // selection support
    selectedItems = [],
    onSelectAll = null,
    selectionEnabled = false,
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userToken = localStorage.getItem("user");
    const userTokenArray = userToken ? JSON.parse(userToken) : "";
    const loginStaffRole = userTokenArray ? userTokenArray.role : "";
    const [localDisplayedData, setLocalDisplayedData] = useState(displayedData);
    const { AccessKeys } = useSelector((state) => state.data);
    const [openAccessPopup, setOpenAccessPopup] = useState(false);
    const [staffAccessOption, setStaffAccessOption] = useState({});
    const [staffId, setStaffId] = useState(0);

    const [openBalancePopup, setOpenBalancePopup] = useState(false);
    const [selectedLedger, setSelectedLedger] = useState(null);
    const [balanceAmount, setBalanceAmount] = useState("");
    const [balanceType, setBalanceType] = useState("debit");
    const [isSubmittingBalance, setIsSubmittingBalance] = useState(false);

    const handleOpenBalancePopup = (item) => {
        setSelectedLedger(item);
        setBalanceAmount(Math.abs(item.openingBalance || 0));
        setBalanceType(item.openingBalance < 0 ? "credit" : (item.openingBalance > 0 ? "debit" : "none"));
        setOpenBalancePopup(true);
    };

    const handleSaveBalance = async (e) => {
        e.preventDefault();
        if (!selectedLedger) return;
        setIsSubmittingBalance(true);
        try {
            const payload = {
                openingBalance: parseFloat(balanceAmount) || 0,
                openingBalanceType: balanceType
            };
            await dispatch(updateLedgerOpeningBalance(selectedLedger._id, payload, () => {
                setOpenBalancePopup(false);
            }));
        } catch (error) {
            console.error("Failed to update opening balance", error);
        } finally {
            setIsSubmittingBalance(false);
        }
    };

    useEffect(() => {
        setLocalDisplayedData(displayedData);
    }, [displayedData]);

    const handleToggleChange = (e, item) => {
        const { checked } = e.target;
        const updatedStatus = checked ? 'active' : 'inactive';
        updateItemStatus(item._id, updatedStatus);
    };

    const updateItemStatus = async (itemId, status) => {
        setLocalDisplayedData((prevItems) =>
            prevItems.map((item) =>
                item._id === itemId ? { ...item, status } : item
            )
        );
        if (urlName === 'place') {
            const action = updatePlaceStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        } else if (urlName === 'category') {
            const action = updatePackageCategoryStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        } else if (urlName === 'package') {
            const action = updatePackageStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
        else if (urlName === 'member') {
            const action = updateTeamStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
        else if (urlName === 'bank-account') {
            const action = updateBankAccountStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
        else if (urlName === 'credit-card') {
            const action = updateCreditCardStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
        else if (urlName === 'phonenumber') {
            const action = updatePhoneNumberStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
        else if (urlName === 'bank-access') {
            const action = updateBankAccessStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
        else if (urlName === 'number-access') {
            const action = updateNumberAccessStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
        else if (urlName === 'blog') {
            const action = updateBlogStatus;
            await dispatch(
                action(
                    itemId,
                    { 'status': status },
                    navigate
                )
            );
        }
    };

    const saveNewOrder = async (newOrder) => {
        if (urlName === 'place') {
            const action = setPlaceSortOrder;
            await dispatch(
                action(newOrder)
            );
        } else if (urlName === 'category') {
            const action = setPackageCategorySortOrder;
            await dispatch(
                action(newOrder)
            );
        } else if (urlName === 'package') {
            const action = setPackageSortOrder;
            await dispatch(
                action(newOrder)
            );
        } else if (urlName === 'blog') {
            const action = setBlogSortOrder;
            await dispatch(
                action(newOrder)
            );
        }
    };

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!over) {
            return; // Do nothing if no valid drop target
        }

        if (active.id !== over.id) {
            setLocalDisplayedData((items) => {
                const oldIndex = items.findIndex((item) => item._id === active.id);
                const newIndex = items.findIndex((item) => item._id === over.id);

                const newItems = arrayMove(items, oldIndex, newIndex);

                const updatedOrder = newItems.map((item, index) => ({
                    _id: item._id,
                    sortOrder: index + 1
                }));
                saveNewOrder(updatedOrder);

                return newItems;
            });
        }
    };

    const showTeamAccessModel = async (itemId, staffAccess) => {
        await dispatch(getAccessKeysData());
        setStaffAccessOption(staffAccess);
        setStaffId(itemId);
        setOpenAccessPopup(true);
    }

    const allSelected = selectionEnabled && Array.isArray(localDisplayedData) && localDisplayedData.length > 0 && localDisplayedData.every(item => selectedItems.includes(item._id));

    const renderThead = () => (
        <thead className="ltr:text-left rtl:text-left uppercase text-sm/[17px]">
            <tr>
                {columns.map((col) => (
                    <th
                        key={col.key}
                        scope="col"
                        className="whitespace-nowrap text-center py-4 font-PoppinsLight text-thirdColor border-[1px] bg-[#FBF7F2]"
                    >
                        {selectionEnabled && col.key === 'name' ? (
                            <div className="flex items-center justify-center gap-2">
                                <input
                                    type="checkbox"
                                    checked={allSelected}
                                    onChange={(e) => onSelectAll && onSelectAll(e.target.checked, localDisplayedData)}
                                    className="h-4 w-4"
                                />
                                {col.label}
                            </div>
                        ) : (
                            col.label
                        )}
                    </th>
                ))}
                {showstatusToggel && (
                    <th
                        scope="col"
                        className="whitespace-nowrap text-center py-4 font-PoppinsLight text-thirdColor border-[1px] bg-[#FBF7F2]"
                    >
                        Status
                    </th>
                )}
                {showActionButtons && (
                    <th
                        scope="col"
                        className="whitespace-nowrap text-center py-4 font-PoppinsLight text-thirdColor border-[1px] bg-[#FBF7F2]"
                    >
                        Actions
                    </th>
                )}
            </tr>
        </thead>
    );

    const renderColumns = (item, { attributes, listeners, setNodeRef, dragStyle, enableDragAndDrop }) => (
        <>
            {columns.map((col, index) => (
                <td
                    key={col.key}
                    data-label={col.label}
                    className="whitespace-nowrap px-4 py-2 border-[1px]"
                    ref={enableDragAndDrop ? setNodeRef : null}
                    style={enableDragAndDrop ? dragStyle : {}}
                    {...(enableDragAndDrop ? attributes : {})}
                    {...(enableDragAndDrop ? listeners : {})}
                >
                    {Array.isArray(item[col.key])
                        ? item[col.key].join(" , ")
                        : col.render(item)
                            ? col.render(item)
                            : "-"}
                </td>
            ))}
            {showstatusToggel && (
                <td className="px-4 py-2 mx-auto w-0">
                    <label className="cursor-pointer">
                        <input
                            type="checkbox"
                            value="1"
                            className="sr-only peer"
                            onChange={(e) => handleToggleChange(e, item)}
                            checked={item.status === "active"}
                        />
                        <div className="relative w-11 h-6 bg-red-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-red-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-red-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-red-600 peer-checked:bg-green-600"></div>
                        <span className="ms-3 text-sm font-medium text-red-900 dark:text-red-300"></span>
                    </label>
                </td>
            )}
            {showActionButtons && (
                <td data-label="Actions" className="whitespace-nowrap px-4 py-2 w-0 border-[1px]">
                    <div>
                        {item.status !== "deleted" ? (
                            <div className="flex items-center gap-1">
                                {urlName.startsWith('team/report/sales') ? (
                                    <Link to={`/${urlName}&staffId=${item?.staffId?._id}&bankId=${item?.accountId._id}`} className="bg-[#0D7EB8] cursor-pointer w-9 h-9 rounded-xl flex justify-center items-center">
                                        <FaRegEye className="text-white text-lg" />
                                    </Link>
                                ) : urlName === 'member' && item.role === 1 && loginStaffRole === 1 ? (
                                    <Link to={`/update-${urlName}/${item?._id}`} className="cursor-pointer w-9 h-10" >
                                        <img src={actionIcon} className="w-8 h-8" alt="img" />
                                    </Link>
                                ) : (

                                    <>
                                        {updateInSamePage && (
                                            <div
                                                onClick={() => updateFunction(item?._id)}
                                                className="cursor-pointer w-9 h-10"
                                            >
                                                <img src={actionIcon} className="w-8 h-8" alt="img" />
                                            </div>
                                        )}
                                        {showPageDetails && (
                                            <Link
                                                to={`/update-${urlName}/${item?._id}`}
                                                className="cursor-pointer w-9 h-10"
                                            >
                                                <img src={actionIcon} className="w-8 h-8" alt="img" />
                                            </Link>
                                        )}
                                        {showUpdatePopup && (
                                            <div onClick={() => handelFindDataByID(item?._id, "Update")} className="cursor-pointer w-9 h-10">
                                                <img src={actionIcon} className="w-8 h-8" alt="img" />
                                            </div>
                                        )}
                                        {urlName === 'tally-ledger' && (
                                            <div onClick={() => handleOpenBalancePopup(item)} className="cursor-pointer w-9 h-10" >
                                                <img src={paymentIcon} className="w-8 h-8" alt="action" />
                                            </div>
                                        )}
                                        {
                                            showDeleteBtn && (
                                                <div
                                                    onClick={() => handelFindDataByID(item?._id, 'Delete')}
                                                    className="cursor-pointer w-9 h-10"
                                                >
                                                    <img src={deleteIcon} className="w-8 h-8" alt="img" />
                                                </div>
                                            )
                                        }
                                        {(urlName === 'place' || urlName === 'package') && (
                                            <Link
                                                to={`/${urlName}/images/${item?._id}`}
                                                className="cursor-pointer w-9 h-10"
                                            >
                                                <img src={galleryIcon} className="w-8 h-8" alt="img" />
                                            </Link>
                                        )}
                                        {(urlName === 'category') && (
                                            <Link to={`/package?category=${item?._id}`} className="bg-[#40a648] cursor-pointer w-8 h-8 rounded-xl flex justify-center items-center -mt-1.5">
                                                <LuShapes className="text-white text-lg" />
                                            </Link>
                                        )}
                                        {showSettingButton && (
                                            <Link
                                                to={`/off-${urlName}/${item?._id}`}
                                                className="cursor-pointer w-9 h-10"
                                            >
                                                <img src={settingDataIcon} className="w-8 h-8" alt="setting" />
                                            </Link>
                                        )}
                                        {urlName === 'member' && item?.role === 2 && (
                                            <div
                                                onClick={() => showTeamAccessModel(item?._id, item?.staffAccess)}
                                                className="cursor-pointer w-9 h-10"
                                            >
                                                <img src={settingDataIcon} className="w-8 h-8" alt="img" />
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        ) : (
                            <div
                                onClick={() =>
                                    dispatch(apiFunctionForDeleteUndo(item?._id))
                                }
                            >
                                <SlActionUndo className="cursor-pointer" />
                            </div>
                        )}
                    </div>
                </td>
            )}
        </>
    );

    return (
        <div className="w-full max-w-full">
            {showTableTitle && (
                <div className="flex flex-wrap justify-between items-center gap-3 pb-3 border-b">
                    <div className="flex items-center gap-5">
                        {title && (
                            <Heading title={`${title}`} />
                        )}
                    </div>
                    <div className="flex flex-wrap gap-3 items-center">
                        <FilterComponent
                            filters={filters}
                            handleFilterChange={handleFilterChange}
                        />
                        {addButtonLabel &&
                            (showPageDetails ? (
                                <Link to={`/create-${urlName}`}>
                                    <Button
                                        img={<IoAddCircleOutline />}
                                        btn={addButtonLabel}
                                        btnPadding={"py-2.5 px-2"}
                                        textColor={"text-white"}
                                        bgColor={"bg-[#0D7EB8]"}
                                        btnRound={"rounded-xl"}
                                    />
                                </Link>
                            ) : (
                                <div onClick={() => setToggleMenu(!toggleMenu)}>
                                    <Button
                                        img={<IoAddCircleOutline />}
                                        btn={addButtonLabel}
                                        btnPadding={"py-2.5 px-2"}
                                        textColor={"text-white"}
                                        bgColor={"bg-[#0D7EB8]"}
                                        btnRound={"rounded-xl"}
                                    />
                                </div>
                            ))}
                        {bookingOnOff && (
                            <Link to="/place/on">
                                <Button
                                    btn={bookingOnOff}
                                    btnPadding={"py-2.5 px-2"}
                                    textColor={"text-white"}
                                    bgColor={"bg-primary"}
                                    btnRound={"rounded-xl"}
                                />
                            </Link>
                        )}
                    </div>
                </div>
            )}
            <div className="w-full max-w-full overflow-x-auto rounded-t-xl mt-3 border border-fifth">
                {totalData === 0 ? (
                    <table className="min-w-full w-full divide-y-2 divide-border tracking-wide rounded-lg">
                        {renderThead()}
                        <tbody className="text-thirdColor font-semibold">
                            <tr>
                                <td className="whitespace-nowrap border-b border-[1px] px-4 py-2" colSpan={columns.length + 1}>
                                    <div className="text-center py-2">Data not found.</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                ) : (
                    <DndContext
                        onDragEnd={handleDragEnd}
                        collisionDetection={closestCenter}
                    >
                        <SortableContext
                            items={localDisplayedData.map(item => item._id)}
                            strategy={verticalListSortingStrategy}
                        >
                            <table className="min-w-full w-full divide-y-2 divide-border tracking-wide rounded-lg">
                                {renderThead()}
                                <tbody className="text-thirdColor font-semibold">
                                    {loading ? (
                                        <tr className={`${styles.model} flex justify-center items-center`}>
                                            <td className="spinner"></td>
                                        </tr>
                                    ) : totalData === 0 ? (
                                        <tr>
                                            <td className="whitespace-nowrap px-4 py-2">
                                                <div className="text-center py-2">Data not found.</div>
                                            </td>

                                        </tr>
                                    ) : (
                                        localDisplayedData.map((item) => (
                                            <SortableRow
                                                key={item._id}
                                                item={item}
                                                renderColumns={renderColumns}
                                                enableDragAndDrop={enableDragAndDrop}
                                            />
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </SortableContext>
                    </DndContext>
                )}
            </div>
            {openAccessPopup && (
                <TeamAccessPopup
                    setToggleMenu={setOpenAccessPopup}
                    defaultAccessKeys={AccessKeys}
                    staffAccessKey={staffAccessOption}
                    staffId={staffId}

                />
            )}
            {openBalancePopup && selectedLedger && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-all duration-300">
                    <div className="relative w-full max-w-md p-6 bg-white rounded-3xl shadow-2xl border border-gray-100 transform transition-transform scale-100 duration-300">
                        {/* Modal Header */}
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                <FaBalanceScale className="text-primary" />
                                Update Opening Balance
                            </h3>
                            <button
                                onClick={() => setOpenBalancePopup(false)}
                                className="p-1 hover:bg-gray-100 rounded-full transition duration-200"
                            >
                                <svg className="w-6 h-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Modal Content */}
                        <form onSubmit={handleSaveBalance} className="space-y-4">
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Ledger Name</label>
                                <div className="px-4 py-3 bg-white border border-gray-200 rounded-2xl text-gray-800 font-medium">
                                    {selectedLedger.name}
                                </div>
                            </div>

                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Financial Year (Non-Editable)</label>
                                <div className="px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl text-gray-400 font-medium">
                                    1 April 2026
                                </div>
                            </div>

                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Amount</label>
                                <input
                                    type="number"
                                    step="any"
                                    required
                                    value={balanceAmount}
                                    onChange={(e) => setBalanceAmount(e.target.value)}
                                    placeholder="Enter Amount"
                                    className="w-full px-4 py-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200 font-medium text-gray-800"
                                />
                            </div>

                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Balance Type</label>
                                <select
                                    value={balanceType}
                                    onChange={(e) => setBalanceType(e.target.value)}
                                    className="w-full px-4 py-3 border border-gray-200 rounded-2xl bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200 font-medium text-gray-800"
                                >
                                    <option value="debit">Debit</option>
                                    <option value="credit">Credit</option>
                                </select>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex gap-3 pt-4 border-t border-gray-100">
                                <button
                                    type="button"
                                    onClick={() => setOpenBalancePopup(false)}
                                    className="flex-1 px-4 py-3 border border-gray-200 text-gray-700 font-semibold rounded-2xl hover:bg-gray-50 transition duration-200"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmittingBalance}
                                    className="flex-1 px-4 py-3 bg-primary text-white font-semibold rounded-2xl hover:bg-opacity-90 disabled:opacity-50 transition duration-200 flex justify-center items-center gap-2"
                                >
                                    {isSubmittingBalance ? (
                                        <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                    ) : (
                                        "Save Changes"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DataTable;